<h2 *ngIf="modus==1" mat-dialog-title>Fachliche Erläuterungen zum Budgetantragstool</h2>
<h2 *ngIf="modus==2" mat-dialog-title>Technische Hinweise zum Budgetantragstool</h2>

<mat-dialog-content *ngIf="modus==1">
  Das Budgetantragstool dient der zentralen Erfassung und Bearbeitung von Budgetanträgen für die HafenCity. <br>
  </mat-dialog-content>
<mat-dialog-content *ngIf="modus==2">
  Das sind die technischen Hinweise zum Budgetantragstool. <br>  
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Schließen</button>
</mat-dialog-actions>

